import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable()
export class SideMenuService {
  sidenav: MatSidenav;
  sidemenuExpanded = true;
  drawerContainer: any;
}
